// SAIT-120: отдельная прокрутка таблиц из редакторского HTML.
function wrapTables(element) {
    element.querySelectorAll('table').forEach((table) => {
        const parent = table.parentElement;
        if (parent.classList.contains('article-table-wrap')) {
            return;
        }
        if (parent.classList.contains('table-responsive')) {
            parent.classList.add('article-table-wrap');
            return;
        }

        const wrapper = element.ownerDocument.createElement('div');
        wrapper.className = 'article-table-wrap';
        wrapper.setAttribute('role', 'region');
        wrapper.setAttribute('aria-label', 'Таблица с данными');
        wrapper.tabIndex = 0;
        parent.insertBefore(wrapper, table);
        wrapper.appendChild(table);
    });
}

export const articleTables = {
    mounted: wrapTables,
    updated: wrapTables
};
